module.exports = __webpack_public_path__ + "static/media/reservation-white.e2ebe221.svg";